import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';
import moment from 'moment';
import { goToUrl } from '../Table/tableActions';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const SPENDBACKS_LOAD = 'SPENDBACKS/SPENDBACKS_LOAD';
export const SPENDBACKS_SUCCESS = 'SPENDBACKS/SPENDBACKS_SUCCESS';
export const SPENDBACKS_FAILURE = 'SPENDBACKS/SPENDBACKS_FAILURE';

export const fetchUrl = `${config.payoutApiUrl}`;

export function selectSpendback(history, spendback, newTab) {
    goToUrl(history, `/spendback/${spendback.id}`, newTab);
}

export function getSpendbacks(filters, page, pageSize, sorters, payoutAccountIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'spendbackDate',
        filters,
        payoutAccountIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getSpendbacksFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/spendback${queryParamsString}`
        },
        loadActionTypeOrCreator: SPENDBACKS_LOAD,
        successActionTypeOrCreator: getSpendbacksSuccessActionCreator
    };
}

export function getSpendbacksSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, SPENDBACKS_SUCCESS, 'spendbacks');
}

export function getSpendbacksFailureActionCreator(error) {
    return {
        error,
        type: SPENDBACKS_FAILURE
    };
}

export function goToSpendbackTable(achDetailId, history) {
    const queryParamsString = createQueryParams({
        dateKey: 'spendbackDate',
        filters: [{
            id: 'id',
            value: achDetailId
        }],
        page: 0,
        pageSize: 10,
        sorters: []
    });
    history.push(`/spendback${queryParamsString}`);
}

export function goToSpendback(history, spendback = {}, newTab) {
    goToUrl(history, `/spendback/${spendback.id}`, newTab);
}

export function getSpendbackTableLink(achDetailId, startDate) {
    const calculatedEndDate = moment().isBefore(moment(startDate).add(1, 'month'))
        ? moment().format('YYYY-MM-DD')
        : moment(startDate).add(1, 'month').format('YYYY-MM-DD');
    const queryParamsString = createQueryParams({
        dateKey: 'spendbackDate',
        filters: [{
            id: 'achDetailsId',
            value: achDetailId
        },
        {
            id: 'startDate',
            value: moment(startDate).subtract(1, 'month').format('YYYY-MM-DD')
        },
        {
            id: 'endDate',
            value: calculatedEndDate
        }],
        page: 0,
        pageSize: 10,
        sorters: []
    });

    return `/spendback${queryParamsString}`;
}

export function getSpendbackLink(spendback = {}) {
    return `/spendback/${spendback.id}`;
}
